export const host = () => {
  if (window.location.href.includes("localhost")) return "http://localhost:9001/mse-corp-action";
  if (window.location.href.includes("nonprod")) {
    if (window.location.href.includes("dev.")) {
      return "https://services-dev.nonprod.plutasgroup.digital/mse-corp-action";
    }

    if (window.location.href.includes("dev2.")) {
      return "https://services-dev2.nonprod.plutasgroup.digital/mse-corp-action";
    }

    if (window.location.href.includes("sit.")) {
      return "https://services-sit.nonprod.plutasgroup.digital/mse-corp-action";
    }

    if (window.location.href.includes("demo.")) {
      return "https://services-demo.nonprod.plutasgroup.digital/mse-corp-action";
    }

    if (window.location.href.includes("uat.")) {
      return "https://services-uat.nonprod.plutasgroup.digital/mse-corp-action";
    }

    if (window.location.href.includes("preprod.")) {
      return "https://services-preprod.nonprod.plutasgroup.digital/mse-corp-action";
    }
  }
  return "https://services-prod.prod.plutasgroup.digital/mse-corp-action";
};
